import React from "react";

export const AIDocumentScanning = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="AI-Document-Scanning">
        <path
          id="Rectangle 2"
          d="M0.9 0.000976562H0.6C0.268629 0.000976562 0 0.26974 0 0.601277V3.00048C0 3.33201 0.268629 3.60078 0.6 3.60078H0.9C1.23137 3.60078 1.5 3.33201 1.5 3.00048V0.601277C1.5 0.26974 1.23137 0.000976562 0.9 0.000976562Z"
          fill="#4F9CF9"
        />
        <path
          id="Path 4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 -0.000244141C3.15913 -0.000244141 3.31174 0.0630015 3.42426 0.17558C3.53679 0.288158 3.6 0.440846 3.6 0.600056V0.900206C3.6 1.05942 3.53679 1.2121 3.42426 1.32468C3.31174 1.43726 3.15913 1.50051 3 1.50051H0.6C0.44087 1.50051 0.288258 1.43726 0.175736 1.32468C0.063214 1.2121 0 1.05942 0 0.900206V0.600056C0 0.440846 0.063214 0.288158 0.175736 0.17558C0.288258 0.0630015 0.44087 -0.000244141 0.6 -0.000244141H3Z"
          fill="#4F9CF9"
        />
        <path
          id="Rectangle 3"
          d="M23.9988 0.900206V0.600056C23.9988 0.268519 23.7302 -0.000244141 23.3988 -0.000244141L21.0008 -0.000244141C20.6694 -0.000244141 20.4008 0.268519 20.4008 0.600056V0.900206C20.4008 1.23174 20.6694 1.50051 21.0008 1.50051L23.3988 1.50051C23.7302 1.50051 23.9988 1.23174 23.9988 0.900206Z"
          fill="#4F9CF9"
        />
        <path
          id="Path 5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.9999 3.00126C23.9999 3.16047 23.9367 3.31315 23.8242 3.42573C23.7117 3.53831 23.5591 3.60156 23.3999 3.60156H23.1007C22.9416 3.60156 22.789 3.53831 22.6765 3.42573C22.5639 3.31315 22.5007 3.16047 22.5007 3.00126V0.600056C22.5007 0.440847 22.5639 0.288158 22.6765 0.17558C22.789 0.0630015 22.9416 -0.000244141 23.1007 -0.000244141H23.3999C23.5591 -0.000244141 23.7117 0.0630015 23.8242 0.17558C23.9367 0.288158 23.9999 0.440847 23.9999 0.600056V3.00126Z"
          fill="#4F9CF9"
        />
        <path
          id="Rectangle 4"
          d="M23.1 23.9985H23.4C23.7314 23.9985 24 23.7298 24 23.3982V20.999C24 20.6675 23.7314 20.3987 23.4 20.3987H23.1C22.7686 20.3987 22.5 20.6675 22.5 20.999V23.3982C22.5 23.7298 22.7686 23.9985 23.1 23.9985Z"
          fill="#4F9CF9"
        />
        <path
          id="Path 6"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9999 23.9986C20.8408 23.9986 20.6882 23.9354 20.5756 23.8228C20.4631 23.7102 20.3999 23.5575 20.3999 23.3983V23.099C20.3999 22.9397 20.4631 22.7871 20.5756 22.6745C20.6882 22.5619 20.8408 22.4987 20.9999 22.4987H23.3999C23.559 22.4987 23.7116 22.5619 23.8242 22.6745C23.9367 22.7871 23.9999 22.9397 23.9999 23.099V23.3983C23.9999 23.5575 23.9367 23.7102 23.8242 23.8228C23.7116 23.9354 23.559 23.9986 23.3999 23.9986H20.9999Z"
          fill="#4F9CF9"
        />
        <path
          id="Rectangle 5"
          d="M0.0012207 23.0993L0.0012207 23.3995C0.0012207 23.731 0.26985 23.9998 0.601221 23.9998H2.99922C3.33059 23.9998 3.59922 23.731 3.59922 23.3995V23.0993C3.59922 22.7678 3.33059 22.499 2.99922 22.499H0.601221C0.26985 22.499 0.0012207 22.7678 0.0012207 23.0993Z"
          fill="#4F9CF9"
        />
        <path
          id="Path 7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 20.9982C0 20.839 0.063214 20.6864 0.175736 20.5738C0.288258 20.4612 0.44087 20.3979 0.6 20.3979H0.8992C0.977993 20.3979 1.05601 20.4135 1.12881 20.4436C1.20161 20.4738 1.26775 20.518 1.32346 20.5738C1.37918 20.6295 1.42338 20.6957 1.45353 20.7685C1.48368 20.8414 1.4992 20.9194 1.4992 20.9982V23.3995C1.4992 23.5587 1.43599 23.7113 1.32346 23.8239C1.21094 23.9365 1.05833 23.9998 0.8992 23.9998H0.6C0.44087 23.9998 0.288258 23.9365 0.175736 23.8239C0.063214 23.7113 0 23.5587 0 23.3995V20.9982Z"
          fill="#4F9CF9"
        />
        <path
          id="Rectangle 6"
          d="M18.9439 6.14038H5.4563C4.75556 6.14038 4.1875 6.70873 4.1875 7.40982V16.7893C4.1875 17.4904 4.75556 18.0587 5.4563 18.0587H18.9439C19.6446 18.0587 20.2127 17.4904 20.2127 16.7893V7.40982C20.2127 6.70873 19.6446 6.14038 18.9439 6.14038Z"
          stroke="#4BCFFF"
          strokeWidth={2}
        />
        <path
          id="Line 3"
          d="M13.5876 10.4174H17.4924"
          stroke="#4BCFFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Line 4"
          d="M13.5876 12.7686H17.4924"
          stroke="#4BCFFF"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Ellipse 2"
          d="M9.07717 11.62C9.83712 11.62 10.4532 11.0036 10.4532 10.2433C10.4532 9.48294 9.83712 8.86658 9.07717 8.86658C8.31723 8.86658 7.70117 9.48294 7.70117 10.2433C7.70117 11.0036 8.31723 11.62 9.07717 11.62Z"
          stroke="#4BCFFF"
          strokeWidth={2}
        />
        <path
          id="Path 8"
          d="M11.8297 15.0625V15.8629C12.0419 15.8629 12.2454 15.7786 12.3954 15.6285C12.5454 15.4784 12.6297 15.2748 12.6297 15.0625H11.8297ZM6.3249 15.0625H5.5249C5.5249 15.2748 5.60919 15.4784 5.75922 15.6285C5.90925 15.7786 6.11273 15.8629 6.3249 15.8629V15.0625ZM11.8297 15.0625V14.2621H9.0773V15.8629H11.8297V15.0625ZM9.0773 14.2621H6.3253L6.3249 15.8629H9.0773V14.2621ZM7.1249 15.0625C7.14367 14.981 7.1776 14.9038 7.2249 14.8348C7.33966 14.6534 7.48235 14.4913 7.6477 14.3546C8.04448 14.0069 8.55009 13.8088 9.0773 13.7943V12.1935C8.17203 12.2072 7.30034 12.5386 6.6145 13.1299C6.3175 13.3778 6.06201 13.6715 5.8577 14C5.65303 14.3165 5.53801 14.6826 5.5249 15.0593L7.1249 15.0625ZM9.0773 13.7975C9.60451 13.812 10.1101 14.0101 10.5069 14.3578C10.6723 14.4945 10.815 14.6566 10.9297 14.838C10.977 14.907 11.011 14.9842 11.0297 15.0657H12.6297C12.6166 14.689 12.5016 14.3229 12.2969 14.0064C12.0925 13.6778 11.8369 13.3841 11.5397 13.1364C10.8539 12.545 9.98217 12.2136 9.0769 12.1999L9.0773 13.7975Z"
          fill="#4BCFFF"
        />
      </g>
    </svg>
  );
};
